// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"a44a8f17","53":"446189ec","249":"b1392f66","335":"e7571276","406":"be57dcab","767":"2bfcdb2f","816":"a39e91cc","873":"032c306a","925":"00599aa9"}[chunkId] + ".chunk.js";
};